import {
    ALL_PRIMITIVE_OPERATORS,
    DatatableFilter, FilterControlType,
    FilterOperator
} from '@common/datatable/datatable-filters/search-input-with-filters/filter-config/datatable-filter';
import {
    CreatedAtFilter,
    TimestampFilter,
    UpdatedAtFilter
} from '@common/datatable/datatable-filters/search-input-with-filters/filter-config/timestamp-filter';
import { FindUserModalComponent } from '@common/auth/find-user-modal/find-user-modal.component';

export const LINK_INDEX_FILTERS: DatatableFilter[] = [
    new DatatableFilter({
        type: FilterControlType.Select,
        key: 'type',
        description: 'Type of the link',
        defaultValue: 'direct',
        options: [
            {key: 'All', value: ''},
            {key: 'Direct', value: 'direct'},
            {key: 'Overlay', value: 'overlay'},
            {key: 'Frame', value: 'frame'},
            {key: 'Custom Page', value: 'link_page'},
        ],
    }),
    new DatatableFilter({
        type: FilterControlType.Select,
        key: 'active',
        label: 'status',
        defaultValue: false,
        description: 'Whether link is disabled or not',
        options: [
            {key: 'enabled', value: false},
            {key: 'disabled', value: true},
        ],
    }),
    new DatatableFilter({
        type: FilterControlType.Select,
        key: 'password',
        description: 'Whether link is password protected',
        options: [
            {key: 'any', value: ''},
            {
                key: 'does not have password',
                value: {value: null, operator: FilterOperator.eq},
            },
            {key: 'has password', value: {value: null, operator: FilterOperator.ne}},
        ],
    }),
    new DatatableFilter({
        type: FilterControlType.Input,
        inputType: 'number',
        key: 'clicks_count',
        label: 'Click Count',
        description: 'Total number of clicks for link',
        defaultValue: 1,
        defaultOperator: FilterOperator.gte,
        operators: ALL_PRIMITIVE_OPERATORS,
    }),
    new TimestampFilter({
        key: 'clicked_at',
        label: 'Clicked At',
        description: 'Date the link was last clicked',
    }),
    new TimestampFilter({
        key: 'expires_at',
        label: 'Expires At',
        description: 'Date the link will expire',
    }),
    new CreatedAtFilter({
        description: 'Date link was created',
    }),
    new UpdatedAtFilter({
        description: 'Date link was last updated',
    }),
    new DatatableFilter({
        type: FilterControlType.SelectModel,
        key: 'user_id',
        label: 'User',
        description: 'User link was created by',
        component: FindUserModalComponent,
    }),
];
